<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.native.enter="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" @click.stop="search()">
          搜索
        </el-button>
      </div>
    </div>

    <div>
      <el-row style="display: flex">
        <el-col>
          <el-tree :data="tableData" :props="defaultProps" node-key="menuId" @node-click="handleNodeClick"
                   highlight-current :default-expanded-keys="defaultExpandedKeys"></el-tree>
        </el-col>
        <el-col>
          <div>
            <el-form v-model="editMenuForm">
              <el-form-item prop="menuCode" label="id" label-width="80px">
                <el-input disabled v-model="editMenuForm.menuId" style="width: 40%"></el-input>
              </el-form-item>
              <!--          <el-form-item prop="menuCode" label="父级菜单" label-width="80px">-->
              <!--            <el-input disabled style="width: 40%" v-text="getParentNodeName()"></el-input>-->
              <!--          </el-form-item>-->
              <el-form-item prop="menuCode" label="菜单名称" label-width="80px">
                <el-input v-model="editMenuForm.menuName" style="width: 40%"></el-input>
              </el-form-item>
              <el-form-item prop="menuCode" label="菜单码" label-width="80px">
                <el-input v-model="editMenuForm.menuCode" style="width: 40%"></el-input>
              </el-form-item>
              <el-form-item prop="menuCode" label="排序" label-width="80px">
                <el-input-number v-model="editMenuForm.sort" style="width: 40%"></el-input-number>
              </el-form-item>
              <el-form-item prop="menuCode" label="是否隐藏" label-width="80px">
                <el-switch v-model="editMenuForm.hidden" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-form>
          </div>

        </el-col>
      </el-row>
    </div>
    <div style="padding-top:20px;display: flex;align-content: center;justify-content: center">
      <el-button size="small" type="primary" @click="addTopMenu()">添加顶层菜单</el-button>
      <el-button :disabled="!hasSelectMenu()" size="small" type="primary" @click="addMenu">添加子菜单</el-button>
      <el-button :disabled="!hasSelectMenu()" size="small" type="success" @click="submitEdit">
        {{ editType === 'edit' ? '保存修改' : '确认添加' }}
      </el-button>
      <el-button :disabled="!hasSelectMenu()" size="small" type="danger" @click="deleteMenu">删除</el-button>
    </div>


  </div>

</template>

<script>
import {addMenu, deleteMenu, getMenuList, updateMenu} from "@/api/menu/menu";
import {handleRes} from "@/utils/handleRes";
import {printObj} from "@/utils/debug";
import {isVaild} from "@/utils/validate";
import {deepClone} from "@/utils";

export default {
  name: "menuList",
  created() {
    this.getMenuList()
  },
  data() {
    return {
      loading: false,
      searchValue: "",
      pageOpt: {
        curPage: 1,
        pageSize: 0,
        total: 0
      },
      tableData: [],
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'childMenuList',
        label: 'menuName',
      },
      curSelectMenu: {},
      editMenuForm: {},
      editType: "",
    }
  },
  methods: {
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getMenuList()
    },
    getMenuList() {
      this.loading = true
      let params = {
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.curPage,
        pageSize: 0,
      }
      getMenuList(params).then((res) => {
        handleRes(res, () => {
          this.pageOpt.total = res.data.total
          this.tableData = res.data.rows
        })
        this.utils.stopLoading(this)
      })
    },
    handleNodeClick(data) {
      this.curSelectMenu = data
      this.editMenuForm = deepClone(this.curSelectMenu)
      this.setCurEditType('edit')
      let index = this.defaultExpandedKeys.indexOf(data.menuId);
      if (index >= 0) {
        this.defaultExpandedKeys.splice(index, 1)
      } else if (isVaild(data.childMenuList) && data.childMenuList.length > 0) {
        this.defaultExpandedKeys.push(data.menuId)
      }
      console.log(this.defaultExpandedKeys)
      // printObj(this.curSelectMenu)
    },
    setCurEditType(type) {
      this.editType = type
    },
    addTopMenu(){
      this.setCurEditType('create')
      this.editMenuForm = {
        menuName: "",
        menuCode: "",
        hidden: 0,
        sort: 0,
      }
    },
    addMenu() {

      if (!this.hasSelectMenu()) {
        this.$message('未选中父菜单，无法添加子菜单。')
        return
      }
      this.setCurEditType('create')
      this.editMenuForm = {
        menuName: "",
        menuCode: "",
        hidden: 0,
        sort: 0,
        parentId: this.curSelectMenu.menuId
      }

    },
    /**
     * 当前是否已经选中了菜单
     * @returns {boolean}
     */
    hasSelectMenu() {
      return (isVaild(this.curSelectMenu) && isVaild(this.curSelectMenu.menuId))
    },
    /**
     * 提交表单
     * 两种行为，创建和修改
     */
    submitEdit() {
      if (!this.hasSelectMenu()) {
        this.$message('未选中菜单，无法操作。')
        return
      }
      let para = deepClone(this.editMenuForm)
      if (para.hidden) {
        para.hidden = 1
      } else {
        para.hidden = 0
      }
      if (this.editType === 'edit') {//修改菜单
        updateMenu(para).then(res => {
          handleRes(res, () => {
            this.getMenuList()
          })
        })
      } else if (this.editType === 'create') {//添加菜单
        addMenu(para).then(res => {
          handleRes(res, () => {
            this.getMenuList()
          })
        })
      }
    },
    /**
     * 删除菜单
     */
    deleteMenu() {
      if (!this.hasSelectMenu()) {
        this.$message('未选中菜单，无法操作。')
        return
      }
      this.$confirm(`确定要删除'${this.curSelectMenu.menuName}'菜单吗？`, "提示").then(value => {
        deleteMenu({
          menuId: this.curSelectMenu.menuId
        }).then(res => {
          handleRes(res, () => {
            this.getMenuList()
          })
        })
      })

    }
  }
}
</script>

<style scoped>
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #000000 !important;
  color: white;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: black;
}

</style>